import { useState, useEffect } from 'react'

/**
 * @description Hook to check touch events.
 * @returns {boolean}
 */

export const useIsTouchDevice = () => {
	const [isTouch, setIsTocuh] = useState(false)

	useEffect(() => {
		try {
			document.createEvent('TouchEvent')
			setIsTocuh(true)
		} catch (e) {
			setIsTocuh(false)
		}
	}, [])

	return isTouch
}
